// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2bd2dcab","455":"d4cb2700","977":"e9c2b52d"}[chunkId] + ".chunk.js";
};